import { useEffect } from "react";
import DigtekNavbar from "@/components/digtek/DigtekNavbar";
import DigtekHero from "@/components/digtek/DigtekHero";
import DigtekStarMarquee from "@/components/digtek/DigtekStarMarquee";
import DigtekLogoStrip from "@/components/digtek/DigtekLogoStrip";
import DigtekServices from "@/components/digtek/DigtekServices";
import DigtekAbout from "@/components/digtek/DigtekAbout";
import DigtekCaseStudies from "@/components/digtek/DigtekCaseStudies";
import DigtekTestimonials from "@/components/digtek/DigtekTestimonials";
import DigtekPricing from "@/components/digtek/DigtekPricing";
import DigtekInsights from "@/components/digtek/DigtekInsights";
import DigtekRocketCTA from "@/components/digtek/DigtekRocketCTA";
import DigtekContact from "@/components/digtek/DigtekContact";
import DigtekFooter from "@/components/digtek/DigtekFooter";

export default function Home() {
    // Scroll-reveal observer
    useEffect(() => {
        const els = document.querySelectorAll(".reveal");
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in");
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -60px 0px" },
        );
        els.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);

    return (
        <main
            data-testid="home-page"
            className="digtek-page min-h-screen"
        >
            <DigtekNavbar />
            <DigtekHero />
            <DigtekStarMarquee />
            <DigtekLogoStrip />
            <DigtekServices />
            <DigtekAbout />
            <DigtekCaseStudies />
            <DigtekTestimonials />
            <DigtekPricing />
            <DigtekInsights />
            <DigtekContact />
            <DigtekRocketCTA />
            <DigtekFooter />
        </main>
    );
}
